import { useNavigate } from "react-router-dom";
import { useRoutines, useStartSession } from "@/hooks/useApi";

export default function SessionNewPage() {
  const navigate = useNavigate();
  const { data: routines = [] } = useRoutines();
  const startMutation = useStartSession();

  async function start(routineId?: string, name?: string) {
    const sessionName =
      name ??
      routines.find((r) => r.id === routineId)?.name ??
      `Session ${new Date().toLocaleDateString()}`;
    const { id } = await startMutation.mutateAsync({ routine_id: routineId, name: sessionName });
    navigate(`/session/${id}`);
  }

  return (
    <div className="p-4 space-y-5">
      <h1 className="text-xl font-semibold">Start Workout</h1>

      <section>
        <h2 className="mb-3 text-sm font-medium text-zinc-400 uppercase tracking-wider">
          From Routine
        </h2>
        {routines.length === 0 ? (
          <p className="text-sm text-zinc-500">No routines. Create one first.</p>
        ) : (
          <ul className="space-y-2">
            {routines.map((r) => (
              <li key={r.id}>
                <button
                  onClick={() => start(r.id)}
                  className="w-full rounded-lg border border-zinc-800 p-3 text-left hover:border-zinc-700 transition-colors"
                >
                  <p className="text-sm font-medium">{r.name}</p>
                  {r.description && (
                    <p className="text-xs text-zinc-500 mt-0.5 truncate">{r.description}</p>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>

      <button
        onClick={() => start(undefined, `Ad-hoc ${new Date().toLocaleDateString()}`)}
        className="w-full rounded-lg border border-dashed border-zinc-700 py-3 text-sm text-zinc-400 hover:border-zinc-600 transition-colors"
      >
        Start empty session
      </button>
    </div>
  );
}
